import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesCoupons } from "../../constants";

export const requestDeleteCoupon = async (couponId: string): Promise<void> => {
  return await instance.delete(buildUrl(ApiRoutesCoupons.Coupons, couponId));
};
